import React, { Component } from 'react';
import "../styles/scrollHighlightText.css";

export default class ScrollHighlightText extends Component {
  render() {
   var text =this.props.list;
   return (
	   <div id="scroll-highlight-text" className="centered-text">
		{text.map(function(name, index){
			return (<div className="small-padding"><h3 className="scroll-highlight-text-item">{name}</h3></div>)
		})}
	  </div>
	)
  }
}



// WEBPACK FOOTER //
// ./src/components/scrollHighlightText.js